import Utils from '~/scripts/services/utils';

export default /* @ngInject */ (/** @type {any} */ $scope) => {
	$scope.uid = Utils.guid();
	if ($scope.form && $scope.form.getComponent) {
		const component = $scope.form.getComponent($scope.component.key);
		if (component.active === undefined) {
			$scope.component.active = 0;
			component.active = 0;
		}
		else {
			$scope.component.active = component.active;
		}
		$scope.component.select = (
			/** @type {Event} */ event,
			/** @type {number} */ index,
			/** @type {string} */ currentTab,
			/** @type {string} */ componentId,
		) => {
			$scope.$broadcast('Form.ktable-redraw', index, currentTab);
			event.preventDefault();
			$scope.component.active = index;
			component.active = index;

			// Ensure the componentId's match (even though they always should).
			if (componentId !== $scope.componentId) {
				return;
			}
			if ($scope.component.event) {
				$scope.$emit($scope.component.event, index, currentTab, $scope.data);
			}
		};
	}
	else {
		$scope.active = 0;
	}
};
